import { render, staticRenderFns } from "./DetailButtons.vue?vue&type=template&id=2f2baee8&"
import script from "./DetailButtons.vue?vue&type=script&lang=js&"
export * from "./DetailButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/jobs/Applications/jobs/WebApps/jobs/dpr-field-calendar/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VLayout})
